// migration-allow(family-importers): the host runs the gallery import for the moved add-to-library button
import { useMutateImportTemplateFromGallery } from '@/hooks/mutation/useMutateImportTemplateFromGallery';
// migration-allow(family-importers): the host reads the user for the moved add-to-library button
import { useQueryUser } from '@/hooks/query/useQueryUser';
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import { useTutorial } from '@/hooks/useTutorial';
import { pendingCommunityTemplateIdAtom } from '@heidi/growth/data';
import { AddToLibraryButton } from '@heidi/templates';
import { useSetAtom } from 'jotai';
import { useRouter } from 'next/router';
import { type ComponentProps } from 'react';

type Props = Omit<ComponentProps<typeof AddToLibraryButton>, 'host'>;

export const AddToLibraryButtonHost = (props: Props) => {
  const { data: userData } = useQueryUser();
  const { isAuthenticated } = useIsAuthenticated();
  const { tutorialStepCurrentPage, panelOpen } = useTutorial();
  const { mutate: importTemplate, isPending } = useMutateImportTemplateFromGallery();
  const setPendingCommunityTemplateId = useSetAtom(pendingCommunityTemplateIdAtom);
  const router = useRouter();

  return (
    <AddToLibraryButton
      {...props}
      host={{
        hasUser: !!userData,
        isAuthenticated: isAuthenticated && !!userData,
        tutorialStepCurrentPage,
        panelOpen,
        isPending,
        importTemplateFromGallery: (templateId) => {
          void importTemplate({
            input: { templateId },
            saveAnyway: false,
          });
        },
        onUnauthenticatedClick: (templateId) => {
          setPendingCommunityTemplateId(templateId);
          void router.push(
            `/onboarding?post_login_redirect_url=${encodeURIComponent('/scribe/my-templates/community-import')}`
          );
        },
      }}
    />
  );
};
